import React, { useEffect, useState } from "react";
import { AutoCompletes } from "../../utils/Custom/custominput";
import { SearchToggleButton } from "../../utils/Custom/Button";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import moment from "moment";
import { fetchQuery } from "../../utils/commonComponent/fetched";
import { generateInspectorSignReport } from "./inspectorSignReportPrint";
import { getPermissions } from "../Pages/rbac/hasAccess";
const notNeededColumn = [
  "status",
  "client_id",
  "servicesNameId",
  "id",
  "inspectorId",
  "jobRegisterId",
];
const InspectorSignReport = (props) => {
  const permissions = getPermissions(props.moduleId);
  const [searched, setSearched] = React.useState(false);

  const [empList, setEmpList] = React.useState([]);
  const [selectedEmpIds, setSelectedEmpIds] = useState([]);
  const [reportSignList, setReportSignList] = React.useState([]);

  // Pagination states
  const [currentPage, setCurrentPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(30);
  const rowsPerPageOptions = [30, 50, 100];
  const totalPages = Math.ceil(reportSignList.length / rowsPerPage);
  const paginatedData = reportSignList.slice(
    currentPage * rowsPerPage,
    currentPage * rowsPerPage + rowsPerPage
  );

  const getQuery = () => {
    let whereConditions = [];

    if (selectedEmpIds?.length > 0) {
      const ids = selectedEmpIds.map((id) => `'${id}'`).join(",");
      whereConditions.push(`u.id IN (${ids})`);
    }

    const whereClause = whereConditions.length
      ? `WHERE ${whereConditions.join(" AND ")}`
      : "";

    const query = `SELECT u.*, emp.name AS inspectorName, u.policyStatus AS inspectorPolicyStatus FROM users u LEFT JOIN employees emp ON emp.id = u.employeeId ${whereClause}`;

    return query.trim();
  };

  const fetchData = async () => {
    try {
      const query = getQuery();
      const userData = await fetchQuery(query);

      setReportSignList(userData);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const fetchInspectorList = async () => {
    try {
      const query = `select * from users where status = 1 and type = 2`;
      const inspecotrList = await fetchQuery(query);
      setEmpList(inspecotrList);
    } catch (error) {
      console.error("Error fetching inspecotrList:", error);
    }
  };

  const handleChangePage = (newPage) => {
    if (newPage >= 0 && newPage < totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
  };

  const handleSearch = () => {
    if (selectedEmpIds.length < 1) {
      alert("Please select a employee.");
      return;
    }
    fetchData();
    setSearched(true);
  };

  const clearSearch = () => {
    setSearched(false);
    setSelectedEmpIds([]);
    setReportSignList([]);
  };

  useEffect(() => {
    fetchInspectorList();
  }, []);

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 my-3">
        <div className="w-full">
          <AutoCompletes
            label="Choose Employee"
            options={empList}
            value={empList.filter((c) =>
              selectedEmpIds?.includes(c.id)
            )}
            onChange={(val) => {
              setSelectedEmpIds(val);
              setSearched(false);
            }}
            isWidth
            valueKey="id"
            labelKey="userName"
            multiple
          />
        </div>
        <div>
          <SearchToggleButton
            searched={searched}
            onSearch={handleSearch}
            onClear={clearSearch}
          />
        </div>
        {reportSignList?.some(r => r.policyStatus === 1) && (permissions.pdfDownload || permissions.allAccess) && (
          <div>
            <button
              className="bg-blue-600 text-white px-4 py-2 rounded"
              onClick={() => {
                const filteredReports = reportSignList.filter(
                  r => r.policyStatus == 1 && selectedEmpIds.includes(r.id)
                );
                generateInspectorSignReport(filteredReports);
              }}
            >
              Download PDF (All)
            </button>
          </div>
        )}
      </div>

      <div className="w-full border rounded-md shadow">
        {/* Table Container with Fixed Height */}
        <div className="overflow-y-auto h-auto max-h-[450px]">
          <table className="min-w-full text-sm text-left text-gray-700">
            <thead className="sticky top-0 bg-blue-50 text-xs font-medium text-gray-600 z-10">
              <tr>
                <th className="px-4 py-3 whitespace-nowrap">Sr. No.</th>
                <th className="px-4 py-3 whitespace-nowrap">User Name</th>
                <th className="px-4 py-3 whitespace-nowrap">Inspection Name</th>
                <th className="px-4 py-3 whitespace-nowrap">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {paginatedData.length > 0 ? (
                paginatedData.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    <td className="px-4 py-3">
                      {currentPage * rowsPerPage + rowIndex + 1}
                    </td>
                    <td className="px-4 py-3">{row.userName || ""}</td>
                    <td className="px-4 py-3">{row.inspectorName || ""}</td>
                    <td className="px-4 py-3">
                      <td className="px-4 py-3">
                        {row.policyStatus == 1 && (permissions.pdfDownload || permissions.allAccess) ? (
                          <button
                            className="bg-green-600 text-white px-3 py-1 rounded"
                            onClick={() => generateInspectorSignReport(row)}
                          >
                            Download PDF
                          </button>
                        ) : (
                          <span className="text-red-500">Policy Acceptance Pending</span>
                        )}
                      </td>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center py-4 text-gray-500">
                    No data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Footer */}
        <div className="flex items-center justify-between px-4 py-2 bg-blue-50 text-sm border-t">
          <div className="flex items-center gap-2">
            <span>Rows per page:</span>
            <select
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
              className="border rounded px-2 py-1 text-sm"
            >
              {rowsPerPageOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-2">
            <span className="text-gray-600">
              {reportSignList.length === 0
                ? "0–0 of 0"
                : `${currentPage * rowsPerPage + 1}–${Math.min(
                  (currentPage + 1) * rowsPerPage,
                  reportSignList.length
                )} of ${reportSignList.length}`}
            </span>
            <button
              onClick={() => handleChangePage(0)}
              disabled={currentPage === 0}
              className="p-1 disabled:opacity-50"
            >
              <FirstPageIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(currentPage - 1)}
              disabled={currentPage === 0}
              className="p-1 disabled:opacity-50"
            >
              <KeyboardArrowLeftIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(currentPage + 1)}
              disabled={currentPage >= totalPages - 1}
              className="p-1 disabled:opacity-50"
            >
              <KeyboardArrowRightIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(totalPages - 1)}
              disabled={currentPage >= totalPages - 1}
              className="p-1 disabled:opacity-50"
            >
              <LastPageIcon fontSize="small" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default InspectorSignReport;
